import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
} from "@angular/core";
import { RenderedService } from "../../rendered.service";
import { BaseScaffoldComponent } from "../base-scaffold/base-scaffold.component";
import { ItemsService } from "../../../../services/items.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "scaffold-select-list-display",
  templateUrl: "./select-list-display.component.html",
  styleUrls: [
    "../../rendered.component.scss",
    "./select-list-display.component.scss",
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectListDisplayComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  public destroy$: Subject<boolean> = new Subject<boolean>();
  selectedValue;
  options;
  itemUpdate;
  watch_value;
  last_keys = [];
  values = {};
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private itemsService: ItemsService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe((trigger) => {
        this.cdr.detectChanges(); //template_name
      });

    this.options = this.item.options;
    this.options.forEach((option) => {
      this.values[option.value] = option;
    });
    this.update();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  update() {
    this.selectedValue = this.value;
    this.cdr.detectChanges();
  }
}
